import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarCheck,
  faInfoCircle,
  faMobile,
  faBan,
  faDownload,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HOST_URL } from "../api/Api";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";

class VoiceDetailReports extends Component {
  constructor(props) {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    super(props);
    this.state = {
      user_id: userId,
      token: userToken,
      voiceDetailsReportList: "",
      responceMessage: "",
      status: "",
      senderid: "",
      mobile: "",
      email: "",
      channel: this.props.match.params.channel,
      dateFrom: this.props.match.params.dateFrom,
      dateTo: this.props.match.params.dateTo,
      SelecteddateFrom: "",
      SelecteddateTo: "",
      successMessage: false,
      errorMessage: "",
      bgColor: "",
      isPopoverOpen: null,
      popoverPosition: "bottom"
    };
    this.popupRef = React.createRef();
  }

  componentDidMount() {
    this.detailsReport();
    this.FilderDetailsWithChannel();
    document.addEventListener('mousedown', this.handleClickOutside);

  }

  componentWillUnmount() {
    // Clean up event listener when the component unmounts
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.setState({ isPopoverOpen: null, });
    }
  };


  handleButtonClick = (index) => {
    this.setState({
      isPopoverOpen: index,
    });
  };

  togglePopover = (i, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Determine whether there is more space above or below
    const popoverPosition = rect.bottom + 200 > viewportHeight ? "top" : "bottom";

    this.setState({ isPopoverOpen: i, popoverPosition });
  };

  detailsReport = async () => {
    //console.log('channel',this.state.channel)
    let paramData = {
      user_id: this.state.user_id,
      method: "details",
      channel: "voice",
      token: this.state.token,
      date_from: this.state.dateFrom,
      date_to: this.state.dateTo
    }
    let { data } = await Axios.post(`${HOST_URL}/user_report.php`, paramData)
    if (data.success === true) {
      if (this.state.channel === "voice") {
        this.setState({ voiceDetailsReportList: data.message });
      }
    } else {
      this.setState({ responceMessage: data.message });
    }
  }

  FilderDetailsWithChannel = async () => {
    this.setState({ voiceDetailsReportList: "" });
    let paramData = {
      user_id: this.state.user_id,
      method: "details",
      channel: "voice",
      token: this.state.token,
      date_from: this.state.dateFrom,
      date_to: this.state.dateTo,
      mobile: this.state.mobile,
      status: this.state.status
    }
    let { data } = await Axios.post(`${HOST_URL}/user_report.php`, paramData)
    if (data.success === true && data.message && data.message.length > 0) {
      if (this.state.channel === "voice") {
        this.setState({
          voiceDetailsReportList: data.message,
          successMessage: false,
          errorMessage: "",
        });
      }
    } else {
      this.setState({
        successMessage: true,
        errorMessage: data.message,
        bgColor: "alert alert-danger alert-dismissible",
      });
    }
  }

  dataDownload() {
    var date1 = new Date(this.state.dateFrom);
    var date2 = new Date(this.state.dateTo);
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    //console.log('Difference_In_Days', Math.trunc(Difference_In_Days))

    if (Math.trunc(Difference_In_Days) <= 15) {
      const formData = new FormData();
      formData.append("user_id", this.state.user_id);
      formData.append("method", "download");
      formData.append("channel", "voice");
      formData.append("token", this.state.token);
      formData.append("date_from", this.state.dateFrom);
      formData.append("date_to", this.state.dateTo);

      fetch(`${HOST_URL}/user_report.php`, {
        method: "POST",
        body: formData
      })
        .then(response => {
          if (!response.ok) throw new Error("Network error");
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "user_report.csv"; // Or detect from server headers
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error("Download failed:", error);
        });
         handleUserLog("", "voice_detailed_report_downloaded", "voice", "User Click on Download Button in report", "voice_detail_report", "", { date_from: this.state.dateFrom, date_to: this.state.dateTo });

    } else {
      document.querySelector("body").scrollTo(0, 0);
      this.setState({
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
        errorMessage: `Please go to the Download Center to download data older than 15 days.`,
      });
       handleUserLog("", "voice_detailed_report_downloaded", "voice", "User Click on Download Button in report", "voice_detail_report", "", { date_from: this.state.dateFrom, date_to: this.state.dateTo });
    }


  }

  dateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateFrom: dated,
      SelecteddateFrom: date,
    });
  };

  dateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateTo: dated,
      SelecteddateTo: date,
    });
  };

  setStatus() {
    if (this.state.channel === "voice") {
      return (
        <>
          <option value=""> All </option>
          <option value="success"> Success </option>
          <option value="failed"> Failed </option>
          <option value="submitted"> Submitted </option>
        </>
      );
    } else {
      return (
        <>
          <option value=""> No Channel Selected </option>
        </>
      );
    }
  }

  render() {
    return (
      <div className="wrapper">
        <DashboardLeftMenu />
        <div className="main">
          <DashboardHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className=" mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong>Voice Reports </strong> Details{" "}
                  </h3>
                </div>
              </div>
              <div className="">
                <div className="card">
                  <div className="">
                    <h5 className="card-title  mt-5">
                      <div className="col-auto ml-auto text-right mt-n1">
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link to="/dashboard/voice-report">
                              <li onClick={() => handleUserLog("", "clicked_today_summary_tab", "voice", "User Click on Today Summary tab in report", "voice_detail_report", "", "")} className="breadcrumb-item">
                                {" "}
                                Today's Summary{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/dashboard/voice-detail-reports/" +
                                "voice/" +
                                this.state.dateFrom +
                                "/" +
                                this.state.dateTo
                              }
                            >
                              {" "}
                              <li onClick={() => handleUserLog("", "clicked_detailed_reports_tab", "voice", "User Click on Detailed Reports tab in report", "voice_detail_report", "", "")} className="breadcrumb-item active">
                                Details{" "}
                              </li>{" "}
                            </Link>
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    {this.state.successMessage ? (
                      <div className={this.state.bgColor} role="alert">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                        <div className="">
                          {this.state.errorMessage}{" "}
                          <Link to="/dashboard/download-centre">
                            Download Centre
                          </Link>
                        </div>
                      </div>
                    ) : null}
                    <div className="filter-option">
                      <h6 className="card-subtitle text-muted">Filter </h6>
                      <div className="row">
                        {/* <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <div>
                              <DatePicker
                                className="form-control btn-block"
                                value={this.state.dateFrom}
                                dateFormat="yyyy/MM/dd"
                                onChange={this.dateFrom}
                                selected={this.state.SelecteddateFrom}
                                placeholderText="From Date"
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateFrom}
                              onChange={this.dateFrom}
                              selected={this.state.SelecteddateFrom}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <div>
                              <DatePicker
                                className="form-control btn-block"
                                dateFormat="yyyy/MM/dd"
                                value={this.state.dateTo}
                                onChange={this.dateTo}
                                selected={this.state.SelecteddateTo}
                                placeholderText="Date To"
                              />
                            </div>
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2 d-flex">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <DatePicker
                              className="form-control"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateTo}
                              onChange={this.dateTo}
                              selected={this.state.SelecteddateTo}
                              placeholderText="Date To"
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faBan} />
                            </div>
                            <select
                              onChange={(event) =>
                                this.setState({ status: event.target.value })
                              }
                              className="form-control"
                            >
                              <option value=""> Select Status </option>
                              {this.setStatus()}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-6">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text">
                              <FontAwesomeIcon icon={faMobile} />
                            </div>
                            {this.state.channel === "email" ? (
                              <input
                                onChange={(event) =>
                                  this.setState({ email: event.target.value })
                                }
                                type="text"
                                placeholder="Enter Email"
                                className="form-control"
                              />
                            ) : (
                              <input
                                onChange={(event) =>
                                  this.setState({ mobile: event.target.value })
                                }
                                type="text"
                                placeholder="Enter Mobile NO"
                                className="form-control"
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <button
                            type="button"
                            onClick={() => {
                              this.dataDownload();
                            }}
                            className="btn-success btn-sm btn-block ml-auto mb-2"
                          >
                            <FontAwesomeIcon icon={faDownload} /> Download
                            Reports{" "}
                          </button>
                        </div>
                        <div className="col-md-3">
                          <button
                            type="button"
                            onClick={() => {
                              // handleUserLog("", "search_button", "voice_detail_report", "User Click on Filter Search Button in report", "voice_detail_report", "", { date_from: this.state.dateFrom, date_to: this.state.dateTo, mobile: this.state.mobile, status: this.state.status });
                              this.FilderDetailsWithChannel();
                            }}
                            className="btn-primary btn-block btn-sm ml-auto"
                          >
                            {" "}
                            <FontAwesomeIcon icon={faSearch} /> Filter Search{" "}
                          </button>
                        </div>
                      </div>
                    </div>

                    <hr />

                    <div className="row">
                      <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                        <div
                          style={{ overflow: "scroll", height: 400 + "px" }}
                          className=" flex-fill"
                        >
                          <div className="">
                            {this.state.channel === "voice" &&
                              this.state.voiceDetailsReportList !== "" ? (
                              <table className="table table-striped table-sm my-0">
                                <thead>
                                  <tr>
                                    <th>Status</th>
                                    <th>Mobile</th>
                                    <th>Cost</th>
                                    <th>TTS Cost</th>
                                    <th>Country</th>
                                    <th>Message</th>
                                    <th>Duration</th>
                                    <th>Keypress</th>
                                    <th>Submitted </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.voiceDetailsReportList.map(
                                    (item, i) => (
                                      <tr>
                                        <td>
                                          {item.status === "Success" ? (
                                            <span className="badge btn-success">
                                              {item.status}
                                            </span>
                                          ) : item.status === "Submitted" ? (
                                            <span className="badge bg-success">
                                              {item.status}
                                            </span>
                                          ) : item.status === "Sent" ? (
                                            <span className="badge bg-primary">
                                              {item.status}
                                            </span>
                                          ) : (
                                            <span className="badge bg-danger">
                                              {item.status}
                                            </span>
                                          )}
                                        </td>

                                        <td>{item.mobile}</td>
                                        <td>{item.voice_cost}</td>
                                        <td>{item.tts_cost}</td>
                                        <td>{item.country}</td>

                                        <td style={{ position: "relative" }}>
                                          <span
                                            className="badge bg-info"
                                            onClick={() =>
                                              this.handleButtonClick(i)
                                            }
                                            data-tip
                                            data-event="click focus"
                                            data-for={"registerTip" + i}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: 15,
                                            }}
                                          >
                                            {" "}
                                            <small
                                              style={{ fontSize: 10 + "px" }}
                                            >
                                              Message Show / Hide{" "}
                                            </small>{" "}
                                            <FontAwesomeIcon
                                              icon={faInfoCircle}
                                              color="yellow"
                                              size={5}
                                            />
                                          </span>
                                          {/* <ReactTooltip
                                            globalEventOff="click"
                                            className="tooltip"
                                            html={true}
                                            clickable={true}
                                            onClick={() => {
                                              ReactTooltip.show(this.fooRef);
                                            }}
                                            id={"registerTip" + i}
                                            place="bottom"
                                            effect="solid"
                                          >
                                            {item.message}
                                          </ReactTooltip> */}
                                          {this.state.isPopoverOpen === i && (
                                            <div ref={this.popupRef} className="message_box">
                                              <div dangerouslySetInnerHTML={{ __html: item.message }}></div>
                                            </div>
                                          )}
                                        </td>

                                        <td>{item.call_duration}</td>
                                        <td>
                                          {item.keypress === "" ||
                                            !item.keypress ? (
                                            "NA"
                                          ) : (
                                            <span className="badge bg-info">
                                              {item.keypress}
                                            </span>
                                          )}
                                        </td>
                                        <td>{item.submitted_on}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            ) : (
                              <div className="text-center">
                                <div className="card-body">
                                  <img
                                    alt="Empty Data"
                                    className="project-empty-img"
                                    src={EmptyImg}
                                  />
                                  <small>
                                    {this.state.responceMessage} in{" "}
                                    <strong> {this.state.channel} </strong>{" "}
                                    Between {this.state.dateFrom} to{" "}
                                    {this.state.dateTo}{" "}
                                  </small>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <DashboardFooter />
        </div>
      </div>
    );
  }
}

export default VoiceDetailReports;